// src/reducers/discountReducer.js

import { types } from '../types/types';

const initialState = {
    editingDiscount: {
        id: 0,
        customerFk: 0,
        productFk: 0,
        measurementUnit: '',
        percentage: 0,
        flat: 0,
        validFrom: '',
        validUntil: '',
        realmFk: '',
        status: true
    }
};

export const discountReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingDiscountInfo:
            return {
                ...state,
                editingDiscount: action.payload
            };

        case types.clearDiscountInfo:
            return {
                ...state,
                editingDiscount: initialState.editingDiscount
            };

        default:
            return state;
    }
};